export interface StartMode {
  testMode: boolean;
  locked: boolean;
}

export function startMode(workflowIsTestMode: boolean, requested: boolean): StartMode {
  return workflowIsTestMode ? { testMode: true, locked: true } : { testMode: requested, locked: false };
}
